import { lazy } from 'react';

export const StripeurlPage = lazy(() => import('./page-list'));